<div id="renameFileFolderModal">
  <form (ngSubmit)="ok()">
    <dialog-header>Rename {{ isFolder ? 'Folder' : 'File' }}</dialog-header>
    <mat-dialog-content>
      <div class="form-group">
        <label for="name">{{ isFolder ? 'Folder' : 'File' }} Name:</label>
        <div [ngClass]="{ 'input-group': !isFolder }">
          <input
            #renameInput
            type="text"
            class="form-control"
            value=""
            required
            id="name"
            name="name"
            [(ngModel)]="renameName"
            (keyup)="update()"
            (focus)="renameInput.select()"
            [focusMe]="{ delay: 250 }"
            [disabled]="isProcessing"
          />
          @if (!isFolder) {
            <span class="input-group-addon">{{ extension }}</span>
          }
        </div>
        <br />
        <div
          class="alert alert-danger"
          role="alert"
          [shown]="!validDestination"
        >
          The new name cannot have slashes.
        </div>
        <div [shown]="errorMessage">
          <div class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="tw-gap-2.5">
      <button
        rv-button
        variant="secondary"
        id="renameFileFolderModalCancelButton"
        type="button"
        (click)="cancel()"
        [disabled]="isProcessing"
      >
        Cancel
      </button>
      <button
        rv-button
        id="renameFileFolderModalSaveButton"
        type="submit"
        [disabled]="isProcessing || !validDestination"
      >
        {{ isProcessing ? 'Saving' : 'Save' }}
      </button>
    </mat-dialog-actions>
  </form>
</div>
